 
import React from 'react';

const Sort: React.FC = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 3H15"
                stroke="#899696"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M1 8H10"
                stroke="#899696"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M1 13H6"
                stroke="#899696"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default Sort;